import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Separator } from '@/components/ui/separator';

const shortcuts = [
  { category: 'Navigation', items: [
    { keys: 'g o', label: 'Go to Content Stream' },
    { keys: 'g s', label: 'Go to Signals' },
    { keys: 'g d', label: 'Go to Data Sources' },
    { keys: 'g i', label: 'Go to Integrations' },
    { keys: 'g a', label: 'Go to Analytics' },
  ]},
  { category: 'Actions', items: [
    { keys: '/', label: 'Focus AI search' },
    { keys: 'Ctrl K', label: 'Focus AI search' },
    { keys: 'n', label: 'New Signal' },
    { keys: 'r', label: 'Refresh content' },
    { keys: 'f', label: 'Toggle filters' },
  ]},
  { category: 'General', items: [
    { keys: '?', label: 'Show keyboard shortcuts' },
    { keys: 'Esc', label: 'Close dialog / blur input' },
  ]},
];

const Key = ({ children }) => (
  <kbd className="inline-flex items-center justify-center min-w-[24px] h-6 px-1.5 font-mono font-medium bg-gray-700 text-gray-300 border-gray-600 rounded shadow-sm">
    {children}
  </kbd>
);

const KeyCombo = ({ keys }) => {
  const parts = keys.split(' ');
  return (
    <div className="flex items-center gap-1">
      {parts.map((part, i) => (
        <React.Fragment key={`${part}-${i}`}>
          <Key>{part}</Key>
          {i < parts.length - 1 && <span className="text-gray-400 text-xs">then</span>}
        </React.Fragment>
      ))}
    </div>
  );
};

const KeyboardShortcutsModal = ({ isOpen, onClose }) => {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-lg bg-gray-800">
        <DialogHeader>
          <DialogTitle className="text-white">Keyboard Shortcuts</DialogTitle>
        </DialogHeader>
        
        <div className="space-y-5 mt-2">
          {shortcuts.map((group) => (
            <div key={group.category}>
              <h3 className="font-semibold text-gray-400 uppercase tracking-wider mb-2">
                {group.category}
              </h3>
              <div className="space-y-2">
                {group.items.map((item) => (
                  <div key={item.keys} className="flex items-center justify-between py-1">
                    <span className="text-gray-300">{item.label}</span>
                    <KeyCombo keys={item.keys} />
                  </div>
                ))}
              </div>
              <Separator className="mt-3" />
            </div>
          ))}
        </div>

        <p className="text-gray-500 mt-2">
          Press <Key>?</Key> anytime to show this help
        </p>
      </DialogContent>
    </Dialog>
  );
};

export default KeyboardShortcutsModal;
